import { Route, Routes } from "react-router-dom";

import { NotFound, NotFoundRedirectRoutes } from "components/NotFound";
import { Routes as SinglePORoutes } from "components/PurchaseOrder";
import { Routes as MultiPORoutes } from "components/Workspace";

const PageRoutes = () => {
  return (
    <Routes>
      <Route path="NotFound/" element={<NotFound />} />
      {MultiPORoutes}
      {SinglePORoutes}
      {NotFoundRedirectRoutes /* MUST BE LAST! see `NotFoundRedirectRoutes`*/}
    </Routes>
  );
};

export default PageRoutes;
